import * as React from "react";
import { EcommProductPrice } from "@arctheme-components/ecommerce/Price/Price";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";
import Alpine from "alpinejs";
import helpers from "../../../../../js/helpers";
import {useEffect,useState} from "react";

export const ProductPrice = ({ product }) => {
    const isMobile = useMobileBreakpoint("1024px");
    const [currencyCode, setCurrencyCode] = useState(window.currency?.name ?? 'AUD');
    const [currencySymbol, setCurrencySymbol] = useState(window.currency?.symbol ?? '$');

    useEffect(() => {
        window.addEventListener('currency_initialised' , (event) => {
            setCurrencyCode(event.detail.currency?.name);
        });
    }, []);

    // Helper function to get price by currency code
    const getPriceByCurrency = (priceRanges, currency, type = "price") => {
        const priceEntry = priceRanges?.find((item) => item[type]?.currency_code === currency);
        return priceEntry?.[type]?.amount || 0;
    };

    // Default prices from compare_at_price and price
    let minPrice = product?.price > 0 ? product?.price / 100 : 0;
    let maxPrice = product?.compare_at_price > 0 ? product?.compare_at_price / 100 : 0;

    // If presentment_price_ranges exist, extract prices for the current currency
    if (product?.presentment_price_ranges) {
        const presentmentMinPrice = getPriceByCurrency(product?.variants[0]?.presentment_prices, currencyCode, "price");
        const presentmentMaxPrice = getPriceByCurrency(product?.variants[0]?.presentment_prices, currencyCode, "compare_at_price");

        // Use presentment prices only if they are available
        minPrice = presentmentMinPrice ?? minPrice;
        maxPrice = presentmentMaxPrice ?? maxPrice;
    }

    product?.variants.map((variant) => {

        const variantComparePrice = variant.compare_at_price;
        if (variantComparePrice > 0 && variantComparePrice > maxPrice) {

            if (!product.average_margin){
                maxPrice = variantComparePrice / 100;

            } else {
                maxPrice = variantComparePrice;

            }
        }
    });

    // Ensure that compare_at_price is treated as a "strike-through price" if higher
    const isOnSale = minPrice > 0 && minPrice < maxPrice;

    // console.log("Min Price:", minPrice, "Max Price:", maxPrice);
    // console.log(product);

    return (
        <div className="product-tile__prices">
            <div className="flex flex-row lg:items-end gap-[4px] lg:gap-[8px]">
                {isOnSale && (
                    <span className={`${isMobile ? "h6" : "h5"}`}>
                        <div className="product__price" data-prodify-price-container="">
                            {currencySymbol}{minPrice.toFixed(0)} {currencyCode}
                        </div>
                    </span>
                )}
                <span className={`${isMobile ? "h6" : "h5"}`}>
                    <div className="product__price flex-row" data-prodify-price-container="">
                        {isOnSale ? (
                            <>
                                <span className="sr-only">Special Price</span>
                                <div className="product__sale-price line-through text-[#C0C0C0]">
                                    {currencySymbol}{maxPrice.toFixed(0)} {currencyCode}
                                </div>
                            </>
                        ) : (
                            <>
                                <span className="sr-only">Regular Price</span>
                                <div className="product__price">
                                    {currencySymbol}{minPrice.toFixed(0)} {currencyCode}
                                </div>
                            </>
                        )}
                    </div>
                </span>
            </div>
        </div>
    );
};
